import Cookies from "js-cookie";
import Pusher from 'pusher-js';
import {sessionStore} from "./sessionStore";

class PusherClient {
    constructor() {
        const token = sessionStore.get("token") ?? (Cookies.get("_f") ? JSON.parse(Cookies.get("_f").toString()) : null);

        if(token) {
            const options = {
                cluster: "eu",
                forceTLS: true,
                authEndpoint: (new URL( '/pusher/auth', process.env.REACT_APP_API_ENTRYPOINT)).href,
                auth: {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            };

            // Self-hosted Pusher-compatible server (Sockudo), always over wss: in preprod/prod
            // behind the API's nginx on 443, locally behind the docker-compose TLS front on
            // 6443 (REACT_APP_PUSHER_PORT). pusher-js lets an explicit wsHost win over the
            // cluster defaults; without the variable the client keeps connecting to the
            // pusher.com "eu" cluster.
            if (process.env.REACT_APP_PUSHER_HOST) {
                const port = Number(process.env.REACT_APP_PUSHER_PORT) || 443;

                Object.assign(options, {
                    wsHost: process.env.REACT_APP_PUSHER_HOST,
                    wsPort: port,
                    wssPort: port,
                    enabledTransports: ['ws', 'wss'],
                    disableStats: true,
                });
            }

            this.pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, options);

            this.subscribe = this.subscribe.bind(this);
        }
    }

    subscribe(channelName) {
        return this.pusher.subscribe('private-' + channelName);
    }
    unbind(eventName) {
        return this.pusher.unbind(eventName)
    }

    unsubscribe(channelName) {
        return this.pusher.unsubscribe(channelName)
    }
}
const pusherClient = new PusherClient();

export default pusherClient;
